import React from 'react';
import '../styles/WhoBenefits.css';

const WhoBenefits: React.FC = () => {

  const testimonials = [
    {
      role: "CEO, Machine Provider (SME)",
      content: "For our mid-size organization running RFQs have always been an extra burden on project managers. Due to limited time, we typically sticked to the suppliers we leveraged before, leaving money on the table. We then tried GordianRFQ. It was simply wonderful to get to quotations automatically. Now I cannot imagine working without it."
    },
    {
      role: "Project Management Head, Parts Supplier",
      content: "In our organization, Project Managers pair up with Procurement teams to organize RFQs. Now PMs pair up with their RFQ Agents, specifically for buying standard parts. This reduced the burden on Procurement Team and it provided the speed PMs always wanted. We also managed to save 15% in a short amount of time."
    },
    {
      role: "Procurement Head, Pharma",
      content: "We tried GordianRFQ in indirect procurement RFQs and we couldn't leave it afterwards. We use it to buy our consumables and standard material. AI found suppliers that we didnt know it existed even in the same neighborhood. Now my procurement team focuses on the hard stuff where humans are needed - everything else we leave it to AI!"
    }
  ];

  return (
    <section className="who-benefits">
      <div className="container">
        <h2 className="section-title">Who Benefits the Most?</h2>
        
        <div className="testimonials-container">
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <div className="quote-icon">❝</div>
                  <p className="testimonial-text">{testimonial.content}</p>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <span className="avatar-initial">{testimonial.role.split(',')[0].charAt(0)}</span>
                    </div>
                    <div className="author-info">
                      <span className="author-role">{testimonial.role}</span>
                      <div className="author-stars">★★★★★</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoBenefits;
